import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../../styles/utils/fill";
import { classNames } from "../../../../utils";
export const ApprovalDelegation = t0 => {
  const $ = _c(15);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      size: t1,
      fill: t2,
      fillAttribute: t3,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const size = t1 === undefined ? 24 : t1;
  const fill = t2 === undefined ? "current" : t2;
  const fillAttribute = t3 === undefined ? "currentColor" : t3;
  let t4;
  if ($[6] !== className || $[7] !== fill) {
    t4 = classNames(fillVariants({
      fill
    }), className);
    $[6] = className;
    $[7] = fill;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <path d="M517-518 347-688l57-56 113 113 227-226 56 56-283 283ZM280-220l278 76 238-74q-5-9-14.5-15.5T760-240H558q-27 0-43-2t-33-8l-93-31 22-78 81 27q17 5 40 8t68 4q0-11-6.5-21T578-354l-234-86h-64v220ZM40-80v-440h304q7 0 14 1.5t13 3.5l235 87q33 12 53.5 42t20.5 66h80q50 0 85 33t35 87v40L560-60l-280-78v58H40Zm80-80h80v-280h-80v280Z" />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== fillAttribute || $[11] !== rest || $[12] !== size || $[13] !== t4) {
    t6 = <svg aria-label="Approval Delegation" className={t4} fill={fillAttribute} height={size} role="img" viewBox="0 -960 960 960" width={size} xmlns="http://www.w3.org/2000/svg" {...rest}>{t5}</svg>;
    $[10] = fillAttribute;
    $[11] = rest;
    $[12] = size;
    $[13] = t4;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};